var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversityGeneralCafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 39.988,
    viewBox: "0 0 40 39.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cafe",
    transform: "translate(0 -0.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55256",
    "data-name": "Path 55256",
    d: "M73.146,4.464H39.284V1.524A1.449,1.449,0,0,1,40.733.075H71.7a1.449,1.449,0,0,1,1.449,1.449v2.94Z",
    transform: "translate(-36.215)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55257",
    "data-name": "Path 55257",
    d: "M5.807,393.8H5.245a.473.473,0,0,1-.47-.523l.942-9.488H8.282l-2.014,9.642A.473.473,0,0,1,5.807,393.8Z",
    transform: "translate(-4.399 -353.732)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55258",
    "data-name": "Path 55258",
    d: "M129.235,393.8h.562a.473.473,0,0,0,.47-.523l-.942-9.488H126.76l2.014,9.642A.473.473,0,0,0,129.235,393.8Z",
    transform: "translate(-116.857 -353.732)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55259",
    "data-name": "Path 55259",
    d: "M.014,235.183v11.039a.643.643,0,0,0,.642.642,2.563,2.563,0,0,0,1.556-2.146l.7-9.428a1.449,1.449,0,1,0-2.895-.107Z",
    transform: "translate(-0.013 -215.403)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55260",
    "data-name": "Path 55260",
    d: "M476.038,233.294a1.449,1.449,0,0,0-1.139,1.523l.7,9.428a2.563,2.563,0,0,0,1.556,2.146.462.462,0,0,0,.642-.425V234.711A1.449,1.449,0,0,0,476.038,233.294Z",
    transform: "translate(-437.795 -214.968)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55261",
    "data-name": "Path 55261",
    d: "M464.757,393.8h.562a.473.473,0,0,0,.47-.523l-.942-9.488h-2.565l2.014,9.642A.473.473,0,0,0,464.757,393.8Z",
    transform: "translate(-426.166 -353.732)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55262",
    "data-name": "Path 55262",
    d: "M341.33,393.8h-.562a.473.473,0,0,1-.47-.523l.942-9.488H343.8l-2.014,9.642A.473.473,0,0,1,341.33,393.8Z",
    transform: "translate(-313.71 -353.732)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55263",
    "data-name": "Path 55263",
    d: "M338.006,370.511h12.523a.556.556,0,0,0,.556-.556,2.1,2.1,0,0,0-2.1-2.1h-9.443a2.1,2.1,0,0,0-2.1,2.1A.556.556,0,0,0,338.006,370.511Z",
    transform: "translate(-311.087 -339.051)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55264",
    "data-name": "Path 55264",
    d: "M234.657,314.806v-5.493h-2.5v5.493a20.232,20.232,0,0,1-.332,3.652,20.24,20.24,0,0,0-.332,3.652V324.5h3.829v-2.394a20.231,20.231,0,0,0-.332-3.652A20.248,20.248,0,0,1,234.657,314.806Z",
    transform: "translate(-213.407 -285.079)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55265",
    "data-name": "Path 55265",
    d: "M135.81,301.942h-20.9a.619.619,0,0,1-.619-.619v-1.648a.619.619,0,0,1,.619-.619h20.9a.619.619,0,0,1,.619.619v1.648A.619.619,0,0,1,135.81,301.942Z",
    transform: "translate(-105.358 -275.622)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55266",
    "data-name": "Path 55266",
    d: "M207.049,486.16h-8.487a.264.264,0,0,1-.264-.264,1.9,1.9,0,0,1,1.9-1.9h5.211a1.9,1.9,0,0,1,1.9,1.9A.265.265,0,0,1,207.049,486.16Z",
    transform: "translate(-182.806 -446.112)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55267",
    "data-name": "Path 55267",
    d: "M13.079,370.511H.556A.556.556,0,0,1,0,369.955a2.1,2.1,0,0,1,2.1-2.1h9.443a2.1,2.1,0,0,1,2.1,2.1A.556.556,0,0,1,13.079,370.511Z",
    transform: "translate(0 -339.051)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55268",
    "data-name": "Path 55268",
    d: "M11.254,39.346H5.611L2.757,45.958l.462.824H8.705l.647-.824Z",
    transform: "translate(-2.542 -36.203)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55269",
    "data-name": "Path 55269",
    d: "M94.718,39.346H89.074l-1.9,6.612.554.824h5.486l.554-.824Z",
    transform: "translate(-80.362 -36.203)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55270",
    "data-name": "Path 55270",
    d: "M178.181,39.346h-5.644l-.951,6.612.554.824h5.486l.554-.824Z",
    transform: "translate(-158.181 -36.203)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55271",
    "data-name": "Path 55271",
    d: "M262.595,45.958l-.951-6.612H256v6.612l.554.824h5.486Z",
    transform: "translate(-236 -36.203)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55272",
    "data-name": "Path 55272",
    d: "M335.784,45.958l-1.9-6.612h-5.644l.951,6.612.554.824h5.486Z",
    transform: "translate(-302.594 -36.203)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55273",
    "data-name": "Path 55273",
    d: "M408.974,45.958l-2.854-6.612h-5.644l1.9,6.612.532.824H408.4Z",
    transform: "translate(-369.19 -36.203)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55274",
    "data-name": "Path 55274",
    d: "M6.054,129a3.3,3.3,0,0,1-3.3-3.3v-1.724H9.352V125.7a3.3,3.3,0,0,1-3.3,3.3Z",
    transform: "translate(-2.542 -114.221)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55275",
    "data-name": "Path 55275",
    d: "M90.469,129a3.3,3.3,0,0,1-3.3-3.3v-1.724h6.595V125.7A3.3,3.3,0,0,1,90.469,129Z",
    transform: "translate(-80.362 -114.221)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55276",
    "data-name": "Path 55276",
    d: "M174.883,129a3.3,3.3,0,0,1-3.3-3.3v-1.724h6.595V125.7A3.3,3.3,0,0,1,174.883,129Z",
    transform: "translate(-158.181 -114.221)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55277",
    "data-name": "Path 55277",
    d: "M259.3,129a3.3,3.3,0,0,1-3.3-3.3v-1.724h6.595V125.7A3.3,3.3,0,0,1,259.3,129Z",
    transform: "translate(-236 -114.221)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55278",
    "data-name": "Path 55278",
    d: "M343.711,129a3.3,3.3,0,0,1-3.3-3.3v-1.724h6.595V125.7A3.3,3.3,0,0,1,343.711,129Z",
    transform: "translate(-313.819 -114.221)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55279",
    "data-name": "Path 55279",
    d: "M428.126,129a3.3,3.3,0,0,1-3.3-3.3v-1.724h6.595V125.7A3.3,3.3,0,0,1,428.126,129Z",
    transform: "translate(-391.639 -114.221)",
    fill: "#aee0d9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralCafe);
export default __webpack_public_path__ + "static/media/university-general-cafe.e8d32bcc1aae7358c476086d9822ea05.svg";
export { ForwardRef as ReactComponent };